export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9944.59b2ec02.jpg";